import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { Message } from 'element-ui'
import { $t } from '@/i18n'
import { buildUriForCall } from '@/helpers/functions/buildUri'

export default {
  namespaced: true,
  state: {
    loadingReportByPortal: false,
    filters: {
      search: ''
    },
    total: 0,
    diffuseur: {
      diffuseurNomDeCode: '',
      nbAnnoncesMax: 0,
      nbAnnoncesQuota: 0,
      modeSelectionAutomatique: '',
      nbAnnoncesSelectionnees: 0,
      id: 0,
      nom: '',
      logo: null
    },
    annonces: [],
    statistiques: {
      idUniq: '',
      idFlux: null,
      annonceur: 0,
      bilanAnnonces: {
        modifies: 0,
        traites: 0,
        identiques: 0,
        ajoutes: 0,
        non_valides: 0,
        diffusees: 0,
        supprimes: 0
      },
      bilanPhotos: [],
      type: '',
      startDate: null,
      endDate: null,
      serveur: '',
      idTraitement: 0,
      idFluxPartenaire: 0,
      codeFluxPartenaire: '',
      nomFluxPartenaire: ''
    },
    messagesExports: []
  },
  getters: {
    getLoadingReportByPortal: (state) => state.loadingReportByPortal,
    getNbAnnoncesMax: (state) => state.diffuseur.nbAnnoncesMax,
    getNbAnnoncesQuota: (state) => state.diffuseur.nbAnnoncesQuota,
    getModeSelectionAutomatique: (state) => state.diffuseur.modeSelectionAutomatique,
    getNbAnnoncesSelectionnees: (state) => state.diffuseur.nbAnnoncesSelectionnees,
    getNomDiffuseur: (state) => state.diffuseur.nom,
    getLogoDiffuseur: (state) => state.diffuseur.logo,
    getStatistics: (state) => state.statistiques,
    getDateEnd: (state) => state.statistiques.endDate,
    getNbAnnoncesTraitees: (state) => state.statistiques.bilanAnnonces.traites,
    getNbAnnoncesDiffusees: (state) => state.statistiques.bilanAnnonces.diffusees,
    getAnnoncesReportByPortal: (state) => state.annonces,
    getFilters: (state) => state.filters,
    getTotalReportPortal: (state) => state.total,
    getMessagesExportDiffusionByPortal: (state) => state.messagesExports
  },
  mutations: {
    setLoadingReportByPortal (state, bool) {
      state.loadingReportByPortal = bool
    },
    setResults (state, data) {
      state.diffuseur = data.diffuseur
      state.statistiques = data.statistiques
      state.annonces = data.annonces
    },
    setTotal (state, total) {
      state.total = total
    },
    setFilters (state, { key, value }) {
      state.filters[key] = value
    },
    setMessagesExport (state, data) {
      state.messagesExports = data
    },
    resetFilter (state) {
      state.filters.search = ''
    }
  },
  actions: {
    loadReportByPortal ({ state, commit, rootState }, { diffuseur }) {
      const language = rootState.app.sitimmoUser.language
      commit('setLoadingReportByPortal', true)
      const path = `/portals/report/${diffuseur}/${language}`
      const url = buildUriForCall(path, state.filters)
      HTTP_HYPER_ESPACE_BACKEND
        .get(url)
        .then(response => {
          commit('setTotal', response.data.total)
          commit('setResults', response.data)
        })
        .catch(() => {
          Message.error($t('serverError500'))
        }).finally(() => {
          commit('setLoadingReportByPortal', false)
        })
    },
    exporterDiffusionByPortal ({ state, commit }) {
      const exportMessages = []
      if (state.annonces.length > 0) {
        const annonces = state.annonces
        annonces.forEach((annonce) => {
          const result = annonce.messages.map(item => ({
            portail: item.nomCodeFluxPartenaire,
            referenceAnnonce: item.annonce,
            codeInterne: item.codeInterne,
            date: item.date,
            message: item.message
          }))
          exportMessages.push(result)
        })
      }
      commit('setMessagesExport', exportMessages.flat())
    }
  }
}
